import React, { useEffect } from "react";
import Slider from "rc-slider";

import SliderTooltip from "./SliderTooltip";
import "rc-slider/assets/index.css";

interface BasemapsSliderProps {
  options: any[];
  selectedBasemap: any;
  setSelectedBasemap: (selectedBasemap: any) => void;
}

const playInterval = 3000;

export default (props: BasemapsSliderProps) => {
  const yearOptions = props.options.filter((option) => option.year);
  const yearOptionsSorted = yearOptions.sort((a, b) => b.year - a.year);
  yearOptions.unshift(props.options[0]);
  const [isPlaying, setIsPlaying] = React.useState(false);

  const marks = yearOptionsSorted.reduce((acc, option, i) => {
    if ((i + 1) % 2 === 0) {
      acc[i] = option.year;
    } else {
      acc[i] = " ";
    }
    return acc;
  }, {});

  useEffect(() => {
    let interval: any;
    if (isPlaying) {
      interval = setInterval(() => {
        const currentIndex = yearOptionsSorted.findIndex(
          (option) => option.year === props.selectedBasemap.year
        );
        const nextIndex = currentIndex + 1;
        const nextBasemap = yearOptionsSorted[nextIndex];
        if (nextBasemap) {
          props.setSelectedBasemap(nextBasemap);
        } else {
          props.setSelectedBasemap(yearOptionsSorted[0]);
        }
      }, playInterval);
    }
    return () => clearInterval(interval);
  }, [isPlaying, yearOptionsSorted]);

  return (
    <>
      <div className="w-full py-3 pt-6 flex items-center pr-5">
        <button
          className="bg-white text-black border border-black rounded-md py-1 mr-4 flex-1 hover:bg-gray-100 cursor-pointer"
          onClick={() => setIsPlaying(!isPlaying)}
        >
          {isPlaying ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="1em"
              height="1em"
              viewBox="0 0 24 24"
            >
              <path fill="currentColor" d="M14 19V5h4v14zm-8 0V5h4v14z"></path>
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="1em"
              height="1em"
              viewBox="0 0 24 24"
            >
              <path fill="currentColor" d="M8 5.14v14l11-7z"></path>
            </svg>
          )}
        </button>
        <Slider
          min={0}
          max={yearOptionsSorted.length - 1}
          marks={marks}
          step={null}
          value={yearOptionsSorted.findIndex(
            (option) => option.year === props.selectedBasemap.year
          )}
          onChange={(value) => {
            setIsPlaying(false);
            props.setSelectedBasemap(yearOptionsSorted[value]);
          }}
          handleRender={(renderProps, values) => {
            const label = yearOptionsSorted[values.value].title;
            return (
              <div {...renderProps.props}>
                <SliderTooltip theme="">{label}</SliderTooltip>
              </div>
            );
          }}
        />
      </div>
    </>
  );
};
